export enum Ajility {
    ParentCompany = 'Ajility Development LLC',
    BaseUrl = 'https://docu-vault.com',
    DBAName = 'Docu-Vault',
    OrganizationId = 1,
    RowsPerTablePage = 20,
    ContactEmail = 'hello@docu-vault.com',
    FoundingDate = '2022-11-20',
    Address = '5340 W Kennedy Blvd',
    Address2 = 'Unit 520',
    City = 'Tampa',
    State = 'FL',
    PostalCode = '33609',
    CompanyPhoneNumber = '+1 (813) 994-6617',
    MaximumOrganizationAvatarAllowed = 5,
}

export const AjilitySocialMedia = {
    data: [
        {
            icon: '/images/social_media/discord.svg',
            socialLink: 'https://discord.gg/qKxymHKSxw',
            title: 'Discord',
        },
        {
            icon: '/images/social_media/x.svg',
            socialLink: 'https://x.com/Docu_Vault',
            title: 'X',
        },
        {
            icon: '/images/social_media/youtube.svg',
            socialLink: 'https://www.youtube.com/@DocuVaultOfficial',
            title: 'YouTube',
        },
        {
            icon: '/images/social_media/instagram.svg',
            socialLink: 'https://www.instagram.com/docuvaultofficial',
            title: 'Instagram',
        },
        {
            icon: '/images/social_media/facebook.svg',
            socialLink: 'https://www.facebook.com/docuvaultofficial',
            title: 'Facebook',
        },
        {
            icon: '/images/social_media/linkedin.svg',
            socialLink: 'https://www.linkedin.com/company/docuvaultofficial',
            title: 'LinkedIn',
        },
    ],
}

export const AjilityConstants = {
    AreaServed: ['US', 'CA', 'UK'],
    ContactPoint: [
        {
            type: 'ContactPoint',
            phone: Ajility.CompanyPhoneNumber,
            contactType: 'Customer Service',
            language: 'English',
        },
        {
            type: 'ContactPoint',
            phone: Ajility.CompanyPhoneNumber,
            contactType: 'Technical Support',
            language: 'English',
        },
    ],
    SocialLinks: [
        'https://linkedin.com/company/docuvaultofficial',
        'https://www.facebook.com/docuvaultofficial',
        'https://www.instagram.com/docuvaultofficial/',
    ],
}
